import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContadorService {
  
  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) { }

  verificarExiste(seqCadastro: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/verificar-existe/${seqCadastro}`);
  }

  buscarDadosContador(seqContador: number, paginaAtivos: number = 1, paginaInativos: number = 1): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/${seqContador}`, {
      params: {
        paginaAtivos: paginaAtivos.toString(),
        paginaInativos: paginaInativos.toString()
      }
    });
  }

  listarContribuintesAtivosGrid(seqContador: number, pagina: number = 1, tamanhoPagina: number = 10): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/${seqContador}/contribuintes/ativos/grid`, {
      params: {
        pagina: pagina.toString(),
        tamanhoPagina: tamanhoPagina.toString()
      }
    });
  }

  listarContribuintesInativosGrid(seqContador: number, pagina: number = 1, tamanhoPagina: number = 10): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/${seqContador}/contribuintes/inativos/grid`, {
      params: {
        pagina: pagina.toString(),
        tamanhoPagina: tamanhoPagina.toString()
      }
    });
  }

  listarContribuintesAtivos(seqContador: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/contribuinte/contador-contribuinte/${seqContador}/contribuintes/ativos`);
  }

  listarContribuintesInativos(seqContador: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/contribuinte/contador-contribuinte/${seqContador}/contribuintes/inativos`);
  }

  revogarVinculo(request: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/revogar`, request);
  }

  listarMotivosRevogacao(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/contribuinte/contador-contribuinte/motivos-revogacao`);
  }

  buscarContadorPorCadastro(seqCadastro: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contribuinte/contador-contribuinte/por-cadastro/${seqCadastro}`);
  }
}
